var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"9c47eb6c757efc44885ea14ce12be40135366831"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/assets/9c47eb6c757efc44885ea14ce12be40135366831";

import * as Sentry from '@sentry/nextjs';
import { AxiosError } from 'axios';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_ENV,

  beforeSend(event, hint) {
    const error = hint?.originalException as AxiosError;

    // CDN 403 에러 필터링
    if (
      error?.response?.status === 403 &&
      error?.config?.url?.includes('chatie_episode_files')
    ) {
      console.warn('Filtering out CDN 403 error:', error.config.url);
      return null; // 이벤트를 Sentry에 전송하지 않음
    }

    return event; // 다른 에러는 정상적으로 전송
  },
  ignoreErrors: [
    'Network Error',
    'A network error',
    'EvalError',
    'QuotaExceededError',
    'This Suspense boundary received an update before it finished hydrating.',
    'Error: This Suspense boundary received an update before it finished hydrating.',
    'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
    'Hydration failed because the initial UI does not match what was rendered on the server.',
    'Text content does not match server-rendered HTML.',
    'A component suspended while responding to synchronous input.',
    'Firebase: Error (auth/network-request-failed).',
    'Request failed with status code 404',
    'Request failed with status code 401',
    'Request failed with status code 400',
    'window.chatieInterface.app',
    'Indexed Database',
    /^[A-Z]$/, // gapi iframe error
    /^M$/, // gapi iframe error
    'Load failed',
    'Failed to fetch',
    'timeout',
    'React error #421',
    'Minified React error #421',
    'https://reactjs.org/docs/error-decoder.html?invariant=421',
    'https://react.dev/errors/421',
    'https://reactjs.org/docs/error-decoder.html?invariant=422', // There was an error while hydrating this Suspense boundary. Switched to client rendering.
    'https://reactjs.org/docs/error-decoder.html?invariant=423', // There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root...
    'https://reactjs.org/docs/error-decoder.html?invariant=425', // Text content does not match server-rendered HTML...,
    '"421": "This Suspense boundary received an update before it finished hydrating.', // Minified React error #421
    'NotAllowedError',
    'NotSupportedError',
    'AbortError',
    'No item matching `id` is found.', // chatie-viewer-v2
    "Cannot read properties of undefined (reading 'id')", // chatie-viewer-v2
    'eT(...) is not a function', // chatie-viewer-v2
    'Cancel rendering route', // next.js
    'Failed to get document because the client is offline.', // firebase
    'Installations: Could not process request. Application offline. (installations/app-offline).', // firebase
    "Failed to execute 'transaction' on 'IDBDatabase'",
    'DatabaseClosedError',
    'ConstraintError',
    'Indexed DB is not supported by current browser (remoteconfig/indexed-db-unavailable)', // firebase
    'IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb', // dexie
    `Failed to execute 'measure' on 'Performance': The mark 'beforeRender' does not exist`, // Next 새버전에서 고쳐짐
    'Cannot inject key into script value', // indexed DB
  ],
  tracesSampleRate: 0,

  initialScope: {
    tags: { area: 'client' },
  },
});
